module.exports = __webpack_public_path__ + "static/overlays-2c98fd6cf54a7f705c586340eaca61aa.gif";